<div class="ng-row mt-42 steps text-list" justify-content-center>
    <div class="ng-col position-relative z-index-1" col-12>
        <div class="ng-row mt-15" align-item-center justify-content-center>
            <div class="ng-col text-align-center position-relative" col-2>
                <div class="steps-text" [ngClass]="this.stepCounter == 1 ? 'active':'' || this.stepCounter == 2 ? 'has-done':'' || this.stepCounter == 3 ? 'has-done':'' || this.stepCounter == 4 ? 'has-done':'' || this.stepCounter == 5 ? 'has-done':''">
                    <span *ngIf="this.actype == 'M' && this.minor"> {{"InformationGuardian" | translate}}</span>
                    <span *ngIf="this.actype != 'M' && !this.minor"> {{"PersonalInformation" | translate}}</span>
                    <span *ngIf="this.actype == 'M' && !this.minor"> {{"InformationMinor" | translate}}</span>
                </div>
            </div>
            <div class="ng-col text-align-center position-relative" col-2>
                <div class="steps-text p-l-r"
                    [ngClass]="this.stepCounter == 2 ? 'active':'' || this.stepCounter == 3 ? 'has-done':'' || this.stepCounter == 4 ? 'has-done':'' || this.stepCounter == 5 ? 'has-done':''">
                    <span> {{"AccountDetails" | translate}}</span>
                </div>
            </div>
            <div class="ng-col text-align-center position-relative" col-2>
                <div class="steps-text"
                    [ngClass]="this.stepCounter == 3 ? 'active':'' || this.stepCounter == 4 ? 'has-done':'' || this.stepCounter == 5 ? 'has-done':''">
                    <span> {{"SupportingDocuments" | translate}}</span>
                </div>
            </div>
            <div class="ng-col text-align-center position-relative" col-2>
                <div class="steps-text"
                    [ngClass]="this.stepCounter == 4 ? 'active':'' || this.stepCounter == 5 ? 'has-done':''">
                    <span> {{"PreviewandSubmit" | translate}}</span>
                </div>
            </div>
            <div class="ng-col text-align-center position-relative" col-2 *ngIf=" this.auth?.data?.onBoardingAccount?.digitalAccount==true"  >
                <div class="steps-text" [ngClass]="this.stepCounter == 5 ? 'active':''">
                    <span> {{"VideoCallVerification" | translate}}</span>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="ng-row steps mt-5" justify-content-center>
    <div class="ng-col position-relative z-index-1" col-12>
        <div class="ng-row" align-item-center justify-content-center>
            <div class="ng-col text-align-center position-relative" col-2>
                <div class="steps-dot"
                    [ngClass]="this.stepCounter == 1 ? 'active':'' || this.stepCounter == 2 ? 'has-done':'' || this.stepCounter == 3 ? 'has-done':'' || this.stepCounter == 4 ? 'has-done':'' || this.stepCounter == 5 ? 'has-done':''">
                    <span>1</span>
                </div>

            </div>
            <div class="ng-col text-align-center position-relative" col-2>
                <div class="steps-dot"
                    [ngClass]="this.stepCounter == 2 ? 'active':'' || this.stepCounter == 3 ? 'has-done':'' || this.stepCounter == 4 ? 'has-done':'' || this.stepCounter == 5 ? 'has-done':''">
                    <span>2</span>
                </div>
            </div>
            <div class="ng-col text-align-center position-relative" col-2>
                <div class="steps-dot"
                    [ngClass]="this.stepCounter == 3 ? 'active':'' || this.stepCounter == 4 ? 'has-done':'' || this.stepCounter == 5 ? 'has-done':''">
                    <span>3</span>
                </div>

            </div>
            <div class="ng-col text-align-center position-relative" col-2>
                <div class="steps-dot"
                    [ngClass]="this.stepCounter == 4 ? 'active':'' || this.stepCounter == 5 ? 'has-done':''">
                    <span>4</span>
                </div>
            </div>
            <div class="ng-col text-align-center position-relative" col-2 *ngIf=" this.auth?.data?.onBoardingAccount?.digitalAccount==true" >
                <div class="steps-dot" [ngClass]="this.stepCounter == 5 ? 'active':''">
                    <span>5</span>
                </div>
            </div>
        </div>
    </div>
</div>